import { defineComponent as r, computed as o } from "vue";
import i from "./index3.js";
import { getUser as p, authUser as m } from "../../../shared/data/user/state/index2.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as t } from "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "@ado/acs-standard-library";
const k = r({
  name: "SignInVuexWrapper",
  components: {
    SignIn: i
  },
  props: {
    showDialog: {
      type: Boolean,
      default: !0
    },
    disableSendingSignInRequestsToOtherHosts: {
      type: Boolean,
      default: !1
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const e = o(
      () => t().accountCreationLink ?? p().accountCreationLink
    ), n = o(
      () => t().signInCompletionHandler ?? m
    );
    return {
      accountCreationLink: e,
      signInCompletionHandler: n
    };
  }
});
export {
  k as default
};
//# sourceMappingURL=index2.js.map
